import React, { useState } from "react";
import Item from "./mainItem";
import products from "./ProductData";
import ContentSlider from "../../Components/ui/ContentSlider";

let MainProducts = React.memo(() => {
  let [selectedProduct, setSelectedProduct] = useState("GSTR 9 & GSTR 9C");

  return (
    <section className=" bg-white relative pt-20 flex flex-col items-center">
      <div className="text-center mb-5 sm:mb-7">
        <p className="text-4xl text-black font-bold">
          Choose EasyGST software for hassle-free{" "}
          <span className="text-[#519980]">GST management!</span>
        </p>
        <p className="text-2xl italic">
          File GSTR-1, GSTR-3B & GSTR-9/9C and Effortlessly Reconcile GSTR-2A/2B
          Data with your Accounts Data.
        </p>
      </div>

      <div className="w-full max-w-7xl">
        <ContentSlider
          data={products}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          AddContent={
            selectedProduct && (
              <div className="list">
                {products
                  .filter((product) => product.name === selectedProduct)
                  .map((product) => (
                    <Item
                      key={product.name}
                      title={product.title}
                      bgImage={product.image}
                      listItems={product.listItems}
                    />
                  ))}
              </div>
            )
          }
        />
      </div>
    </section>
  );
});

export default MainProducts;
